import { isNullOrUndefined, ReadonlyRecord } from '@bimser/core';
import { List, Record } from 'immutable';
import { IMenuItem, MenuItem, MenuItemFactoryFromJS } from '../../../../common/entities/IMenuItem';
import {
	IMenuDesignerState,
	MenuDesignerState,
	MenuDesignerStateFactoryFromJS,
	MenuDesignerStateFactory
} from './IMenuDesignerState';
import {
	IEBA6Integration,
	EBA6IntegrationFactory,
	EBA6IntegrationFactoryFromJS,
	EBA6Integration
} from './IEBA6IntegrationState';
import { panelType } from '@bimser/common';

interface IBaseLeftMenuState {
	activePanelId: string;
	activePanelType: panelType;
	activeNodeKey?: string;
	showLoading?: boolean;
	saveAllLoading?: boolean;
	isPinned?: boolean;
}

export interface ILeftMenuState extends IBaseLeftMenuState {
	items: Array<IMenuItem>;
	menuDesigner: IMenuDesignerState;
	eBA6Integration?: IEBA6Integration;
}

interface IReadOnlyLeftMenuState extends IBaseLeftMenuState {
	items: List<MenuItem>;
	menuDesigner: MenuDesignerState;
	eBA6Integration?: EBA6Integration;
}

export type LeftMenuState = ReadonlyRecord<IReadOnlyLeftMenuState>;

export const LeftMenuStateFactory = Record<IReadOnlyLeftMenuState>({
	items: List<MenuItem>(),
	activePanelId: '',
	activePanelType: panelType.startupLayout,
	activeNodeKey: '',
	showLoading: false,
	saveAllLoading: false,
	eBA6Integration: EBA6IntegrationFactory(),
	menuDesigner: MenuDesignerStateFactory(),
	isPinned: localStorage.getItem('webInterfaceLeftMenuPinned') === '1'
});

export const LeftMenuStateFactoryFromJS = function (data: ILeftMenuState) {
	const _items: Array<MenuItem> =
		data.items && data.items.length ? data.items.map(item => MenuItemFactoryFromJS(item)) : [];

	return LeftMenuStateFactory({
		items: List(_items),
		activePanelId: data.activePanelId,
		activePanelType: data.activePanelType,
		activeNodeKey: data.activeNodeKey,
		showLoading: data.showLoading,
		saveAllLoading: data.saveAllLoading,
		menuDesigner: MenuDesignerStateFactoryFromJS(data.menuDesigner),
		eBA6Integration: EBA6IntegrationFactoryFromJS(data.eBA6Integration),
		isPinned: isNullOrUndefined(data.isPinned)
			? localStorage.getItem('webInterfaceLeftMenuPinned') === '1'
			: data.isPinned
	});
};
